import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import UdsDiagnosticSimulator from '../components/tools/uds/UdsDiagnosticSimulator';

const UdsSimulatorPage = () => {
  return (
    <div className="min-h-screen" data-testid="uds-simulator-page">
      <PageHero
        eyebrow="Diagnostic Tools"
        title="UDS Diagnostic Session Simulator"
        description="Run a stateful UDS (ISO 14229) request/response session against a virtual ECU — session control, security access, DID read/write, and DTC memory all persist and affect what's valid next, just like a real bench setup."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="uds-simulator-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <UdsDiagnosticSimulator />
          <ToolGuideCta guidePath="/tools/diagnostic/uds-simulator/guide" toolName="UDS Diagnostic Session Simulator" />
        </div>
      </section>
    </div>
  );
};

export default UdsSimulatorPage;
